// src/features/zepid-tube/components/ZepidTubeSkeleton.tsx

export const ZepidTubeSkeleton = () => {
  return (
    <section className="newsletter padding-top padding-bottom section-bg">
      <div className="container">
        <div className="row zepidtube placeholder-glow">
          {/* Left Column Skeleton */}
          <div className="col-md-6 content">
            <div
              className="placeholder w-75 mb-3"
              style={{ height: '36px' }}
            ></div>
            <div className="placeholder w-100"></div>
            <div className="placeholder w-100"></div>
            <div className="placeholder w-50 mb-4"></div>
            <div
              className="placeholder"
              style={{ width: '150px', height: '48px' }}
            ></div>
          </div>
          {/* Right Column Skeleton */}
          <div className="col-md-6">
            <div className="zepidtube-image mx-auto mt-4">
              <div
                className="placeholder"
                style={{ width: '289px', height: '401px' }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
